import { DateTime, Duration } from 'luxon';
import { secondsToMiliseconds } from './Constants';

export class TokenInfo {
    token: string;
    expiryDateTime: string;

    constructor(token: string, expiryDateTime: string) {
        this.token = token;
        this.expiryDateTime = expiryDateTime;
    }

    public isValid = (secondsBeforeExpiration: number): boolean => {
        const currentTime = DateTime.local();
        const refreshTime = DateTime.fromISO(this.expiryDateTime).minus(Duration.fromMillis(secondsBeforeExpiration * secondsToMiliseconds));
        // Current time should be less than the refresh time otherwise the token would need refresh and would not be valid
        const valid: boolean = currentTime < refreshTime;
        return valid;
    }
}
